/**
 * Owner: Masa Bayu
 * File: text-paint.ts
 * Date:Time: 2026-10-14 02:57
 * Description: L4 paintTextFromTip · tip textAlign only · no decide.
 */

import type { TextPaintInput, TextPaintStyle } from './types.js';

function pt(n: number): string {
  return `${n}pt`;
}

/**
 * Passive text paint from tip.
 * textAlign := tip.style.textAlign only · G1 bbox → placement.
 */
export function paintTextFromTip(input: TextPaintInput): TextPaintStyle {
  const { element } = input;
  const { bbox, style } = element;
  const textAlign = style.textAlign;

  const base: TextPaintStyle = {
    position: 'absolute',
    left: pt(bbox.x),
    top: pt(bbox.y),
    width: pt(bbox.width),
    height: pt(bbox.height),
    fontFamily: style.fontFamily,
    fontSize: pt(style.fontSize),
    textAlign,
    whiteSpace: 'pre',
    dataTextAlign: textAlign,
  };

  /* CSS `text-align` tidak menguat baris TERAKHIR satu-baris (whiteSpace:'pre') ·
   * baris terakhir dikawal `text-align-last`. Sama seperti kontrak enjin mutlak
   * (absolute-placement-plugin.tsx:334) · 'left' dibiang undefined kerana itu
   * sudah nilai lalai CSS. */
  if (textAlign === 'justify' || textAlign === 'center' || textAlign === 'right') {
    return { ...base, textAlignLast: textAlign };
  }

  return base;
}
